{
  "processing": "認証を処理しています...",
  "loadingIframe": "本人確認を読み込んでいます...",
  "issueTitle": "本人確認の問題",
  "notConfigured": "この倉庫では本人確認が正しく設定されていません。",
  "notSuccessful": "本人確認に失敗しました。もう一度お試しいただくか、倉庫にお問い合わせください。",
  "couldNotCompleteProceed": "本人確認を完了できませんでしたが、チェックインを続行できます。",
  "processFailed": "本人確認の処理に失敗しました。もう一度お試しください。",
  "processingFailedProceed": "本人確認の処理に失敗しましたが、チェックインを続行できます。",
  "genericError": "本人確認中にエラーが発生しました。もう一度お試しください。",
  "issueProceed": "本人確認で問題が発生しましたが、チェックインを続行できます。",
  "requiredTryAgain": "チェックインを完了するには本人確認が必要です。もう一度お試しください。",
  "checkInFailedTitle": "チェックインできません",
  "checkInFailedMessage": "身分証明書を確認できませんでした"
}
